import { db } from '../config/firebase';
import { collection, getDocs, addDoc, updateDoc, doc, getDoc, deleteDoc } from 'firebase/firestore';

export const fetchClients = async () => {
  const clientsSnapshot = await getDocs(collection(db, 'clients'));
  return clientsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const fetchQuotes = async () => {
  const quotesSnapshot = await getDocs(collection(db, 'quotes'));
  return quotesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const createQuote = async (quote) => {
  console.info(quote);
  if (quote.hasOwnProperty('total')) {
    delete quote.total;
  }
  
  // S'assurer que les dates sont bien définies et au bon format
  if (!quote.created) {
    quote.created = new Date();
  } else if (!(quote.created instanceof Date)) {
    quote.created = new Date(quote.created);
  }
  
  if (quote.prestaDate && !(quote.prestaDate instanceof Date)) {
    quote.prestaDate = new Date(quote.prestaDate);
  }
  
  try {
    const docRef = await addDoc(collection(db, 'quotes'), quote);
    return docRef.id;
  } catch (error) {
    console.error('Error adding document: ', error);
    throw error;
  }
};

export const updateQuote = async (quoteId, quote) => {
  try {
    await updateDoc(doc(db, 'quotes', quoteId), quote);
  } catch (error) {
    console.error('Error updating document: ', error);
  }
};

export const deleteQuote = async (quoteId) => {
  try {
    await deleteDoc(doc(db, 'quotes', quoteId));
  } catch (error) {
    console.error('Error deleting document: ', error);
  }
};

export const fetchClientById = async (clientId) => {
  const clientDoc = await getDoc(doc(db, 'clients', clientId));
  return { id: clientDoc.id, ...clientDoc.data() };
};

export const fetchQuoteById = async (quoteId) => {
  try {
    const quoteDoc = await getDoc(doc(db, 'quotes', quoteId));
    if (quoteDoc.exists()) {
      return { id: quoteDoc.id, ...quoteDoc.data() };
    } else {
      console.error('Aucun devis trouvé avec cet ID:', quoteId);
      return null;
    }
  } catch (error) {
    console.error('Erreur lors de la récupération du devis:', error);
    return null;
  }
};
